import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/var/www/vhost/sync-frontend/src/@core/contexts/settingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/@layouts/components/vertical/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/@layouts/components/vertical/LayoutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/@layouts/components/vertical/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/@layouts/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "/var/www/vhost/sync-frontend/src/@menu/contexts/verticalNavContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/components/layout/vertical/FooterContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/components/layout/vertical/NavbarContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/components/layout/vertical/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/components/theme/index.tsx");
